import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
    path: '/marketingCenter',
    component: () =>
        import ('@/layout/index'),
    redirect: 'marketingCenter/commission',
    meta: {
        title: i18n.t('ying-xiao-zhong-xin'),
        icon: 'icon-yingxiao1',
        perms: ['bee:marketing']
    },
    children: [{
            path: 'commission',
            component: () =>
                import ('@/module/marketingCenter/page/commission/manage.vue'),
            meta: {
                title: i18n.t('yong-jin-guan-li'),
                icon: 'icon-huodong1',
                perms: ['bee:marketing:commission']
            }
        },
        {
            path: 'advertisingManagement',
            component: () =>
                import ('@/module/marketingCenter/page/advert/manage.vue'),
            meta: {
                icon: 'icon-guanggao',
                title: i18n.t('guang-gao-guan-li'),
                perms: ['bee:marketing:advert']
            }
        },
        {
            path: 'notice',
            component: () =>
                import ('@/module/marketingCenter/page/notice/manage.vue'),
            meta: {
                icon: 'icon-gonggao',
                title: i18n.t('huo-dong-gong-gao'),
                perms: ['bee:marketing:notice']
            }
        },
        {
            path: 'couponManagement',
            component: () =>
                import ('@/module/marketingCenter/page/coupon/manage.vue'),
            meta: {
                icon: 'icon-youhui',
                title: i18n.t('you-hui-quan-guan-li'),
                perms: ['bee:marketing:coupon']
            }
        }
    ]
}]


// WEBPACK FOOTER //
// ./src/module/marketingCenter/router/index.js